import { render, staticRenderFns } from "./BranchedDorms.vue?vue&type=template&id=33a304d7&scoped=true&"
import script from "./BranchedDorms.vue?vue&type=script&lang=js&"
export * from "./BranchedDorms.vue?vue&type=script&lang=js&"
import style0 from "./BranchedDorms.vue?vue&type=style&index=0&id=33a304d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a304d7",
  null
  
)

export default component.exports